import { getSubscriptionProducts } from 'helpers/getPlans';

import { EReduxTypes } from 'ts/enums/redux.types';
import type { IReduxAction } from 'ts/interfaces/redux/redux.action';
import type { ISubscription } from 'ts/interfaces/subscriptions/subscriptions';

const initialState: ISubscription = {
  subscription: null,
  selectedPlan: null,
  plans: [],
  cancelPlan: null,
  order: null,
  payment: null,
  invoice: null,
  productId: null,
  activeProduct: null,
  currentUpsalePlan: null
};

const subscriptionsReducer = (state = initialState, action: IReduxAction): ISubscription => {
  switch (action.type) {
    case EReduxTypes.SIGN_OUT: {
      return initialState;
    }

    case EReduxTypes.SET_SELECTED_PLAN_ID: {
      return {
        ...state,
        selectedPlan: action.data.plan
      };
    }

    case EReduxTypes.SET_ORDER_DATA: {
      return {
        ...state,
        order: action.data
      };
    }

    case EReduxTypes.GET_PLANS: {
      const { plans, cancelPlan } = getSubscriptionProducts(
        action.data.userCountry,
        action.payload,
        action.data.newSalesVariant,
        action.data.germanyFreeTrial,
        action.data.newSales248
      );

      return {
        ...state,
        // @ts-expect-error types seems wrong here, need to review
        plans,
        // @ts-expect-error types seems wrong here, need to review
        cancelPlan
      };
    }

    case EReduxTypes.GET_INVOICE_LINK_AND_ACTIVE_PRODUCT: {
      return {
        ...state,
        invoice: action.payload,
        activeProduct: action.payload?.active_product
      };
    }

    case EReduxTypes.GET_PRODUCT_ID_BY_NAME: {
      const product = action.payload?.find((product: any) => product.name === action.data.productName);

      return {
        ...state,
        productId: product ? product.id : null
      };
    }

    case EReduxTypes.GET_INVOICES: {
      return {
        ...state,
        // @ts-expect-error types seems wrong here, need to review
        payment: action.payload
      };
    }

    case EReduxTypes.UPSALE_CURRENT_PLAN: {
      return {
        ...state,
        currentUpsalePlan: action.data
      };
    }

    default:
      return state;
  }
};

export default subscriptionsReducer;
